{
    "Section_Header": "Invia a Opzioni:",
    "Section_SubHeader": "Inviare i report a:",
    "Validation_Valid_Domain_Name": "L'email deve essere valida",
    "Validation_Valid_Same_As_User": "L'email deve essere nello stesso dominio dell'utente corrente",
    "Validation_Valid_Non_Blacklisted_Email": "L'email non deve appartenere a un dominio inserito nella blacklist",
    "Validation_Valid_Max_Custom_Domains": "Puoi aggiungere solo un massimo di {} email personalizzate",
    "Validation_Valid_Max_Entries": "Non puoi avere più di {} email",
    "NAME": "ReportSchedulingEmails"
}